import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-[#f5f5f5] p-4 sm:p-6 lg:p-8">
      <div className="max-w-4xl mx-auto p-4 lg:p-6">
        <h1 className="text-2xl font-bold mb-4">Leafwell Farm Licensed Housing Agreement</h1>
        <p className="mb-4">
          This User Agreement (the "Agreement") is entered into by and between Leafwell Farm (the "Licensor") and the undersigned individual (the "Licensee"). By registering and using the agricultural housing space through leafwellfarm.com or a similar booking site such as Airbnb, the Licensee agrees to the following terms and conditions:
        </p>
        
        <h2 className="text-xl font-semibold mb-2">License Grant</h2>
        <ul className="list-disc pl-6 mb-4">
          <li>The Licensor grants the Licensee a temporary, revocable license to use the agricultural housing space (the "Space") for the duration of the work agreement as specified in the booking confirmation from leafwellfarm.com or a similar booking site.</li>
          <li>This license is solely for the purpose of housing the Licensee while performing work for Leafwell Farm and does not establish any landlord-tenant relationship. The Licensee acknowledges that they are not a tenant and have no rights to the property as a renter.</li>
        </ul>
        
        <h2 className="text-xl font-semibold mb-2">Use of the Space</h2>
        <ul className="list-disc pl-6 mb-4">
          <li>The Licensee agrees to keep the Space neat and orderly, maintaining it in the same condition as it was at the beginning of the license period.</li>
          <li>Upon the expiration of the work agreement, the Licensee shall return the Space in the same condition as at the commencement of the license.</li>
          <li>The Licensee shall not make any alterations to the Space without prior written consent from the Licensor.</li>
        </ul>
        
        <h2 className="text-xl font-semibold mb-2">Duration of License</h2>
        <ul className="list-disc pl-6 mb-4">
          <li>The license to use the Space is granted for the period specified in the booking confirmation from the booking website.</li>
          <li>This license automatically terminates upon the expiration of the booking date specified in the confirmation from the booking website, with no further notification necessary from the Licensor.</li>
          <li>Check-in time for the Space is 2:00 PM, and check-out time is 12:00 PM, unless otherwise agreed upon by the work manager on-site.</li>
        </ul>
        
        <h2 className="text-xl font-semibold mb-2">Overstay and Enforcement</h2>
        <ul className="list-disc pl-6 mb-4">
          <li>If the Licensee overstays their work license, the Licensor reserves the right to contact the sheriff's office to have the Licensee immediately trespassed and removed from the property.</li>
          <li>Any such breach of this Agreement resulting in overstay will be considered a loss to Leafwell Farm, and the Licensor reserves the right to pursue personal recovery against the Licensee for any damages incurred.</li>
        </ul>
        
        <h2 className="text-xl font-semibold mb-2">Payment and Compensation</h2>
        <ul className="list-disc pl-6 mb-4">
          <li>Leafwell Farm agrees to pay the difference between the booking rate for the housing and the sales of its produce or production within 30 days of receiving payment.</li>
          <li>If no payment is made from the sales of produce or production within the specified time, the housing costs are deemed earned by Leafwell Farm and are not returnable, cancellable, or refundable.</li>
        </ul>
        
        <h2 className="text-xl font-semibold mb-2">Termination</h2>
        <ul className="list-disc pl-6 mb-4">
          <li>The Licensor reserves the right to terminate this Agreement and revoke the license granted herein if the Licensee violates any terms of this Agreement or the work agreement.</li>
          <li>Upon termination, the Licensee shall vacate the Space immediately and return it in the condition required under this Agreement.</li>
        </ul>
        
        <h2 className="text-xl font-semibold mb-2">Indemnity and Liability</h2>
        <ul className="list-disc pl-6 mb-4">
          <li>The Licensee agrees to indemnify and hold harmless the Licensor from any and all claims, damages, or liabilities arising out of or in connection with the Licensee's use of the Space.</li>
          <li>The Licensor is not liable for any personal property damage or loss that occurs within the Space during the license period.</li>
        </ul>
        
        <h2 className="text-xl font-semibold mb-2">Governing Law</h2>
        <p className="mb-4">
          This Agreement shall be governed by and construed in accordance with the laws of the state in which Leafwell Farm is located.
        </p>
        
        <h2 className="text-xl font-semibold mb-2">Entire Agreement</h2>
        <p>
          This Agreement constitutes the entire agreement between the parties and supersedes any prior understandings, agreements, or representations. By using the agricultural housing space, the Licensee acknowledges that they have read, understood, and agree to be bound by the terms and conditions of this Agreement.
        </p>
      </div>
    </div>
  );
};

export default TermsAndConditions;
